import { useEffect, useState } from 'react';
import { Link, Navigate, useLocation } from 'react-router-dom';
import {
    isExternalRedirectTarget,
    isSafeRedirectTarget,
    parseQrRedirectTarget,
} from '../../utils/qrRedirect';

export default function QrRedirect() {
    const location = useLocation();
    const target = parseQrRedirectTarget(location.search);
    const [error, setError] = useState('');

    useEffect(() => {
        if (!target) {
            setError('Invalid QR link — missing destination URL.');
            return;
        }

        if (!isSafeRedirectTarget(target)) {
            setError('Invalid QR link — destination must be an http(s) URL or site path.');
            return;
        }

        if (isExternalRedirectTarget(target)) {
            window.location.replace(target);
        }
    }, [target]);

    if (target && isSafeRedirectTarget(target)) {
        if (isExternalRedirectTarget(target)) {
            return (
                <div style={{ padding: '2rem', textAlign: 'center', fontFamily: 'system-ui, sans-serif' }}>
                    <p>Redirecting…</p>
                </div>
            );
        }

        return <Navigate to={target} replace />;
    }

    return (
        <div style={{ padding: '2rem', textAlign: 'center', fontFamily: 'system-ui, sans-serif' }}>
            <h1 style={{ fontSize: '1.25rem', marginBottom: '0.75rem' }}>QR redirect</h1>
            <p style={{ marginBottom: '1.25rem', color: '#555' }}>{error}</p>
            <Link to="/" style={{ color: '#2563eb' }}>Go to INVERT home</Link>
        </div>
    );
}
